import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData,
  type RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError,
  type RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostResponses,
  refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost,
} from '../../generated';

export type RefreshPdpMutationVariables = RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData['path'];

export type RefreshPdpMutation =
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostResponses[keyof RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostResponses];

export const useRefreshPdpMutation = <
  TError = RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<RefreshPdpMutation, TError, RefreshPdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<RefreshPdpMutation, TError, RefreshPdpMutationVariables, TContext>({
    mutationKey: ['RefreshPdp'],
    mutationFn: async ({ portfolio_id, pdp_id }: RefreshPdpMutationVariables) => {
      const { data } = await refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost({
        path: { portfolio_id, pdp_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useRefreshPdpMutation.fetcher = (
  { portfolio_id, pdp_id }: RefreshPdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost({
      path: { portfolio_id, pdp_id },
      throwOnError: true,
    });
    return data;
  };
};
